export default "__VITE_ASSET__45d61340__"